import { Component, Input, SimpleChanges } from '@angular/core';
import { filterZeroValuesForChart } from '@piqet-angular/data';
import { commonEnum, reportTitals } from '@piqet-angular/shared';

@Component({
  selector: 'piqet-angular-report-bar-chart',
  templateUrl: './report-bar-chart.component.html',
  styleUrls: ['./report-bar-chart.component.scss'],
})
export class ReportBarChartComponent {
  chartOpacity: any = { value: commonEnum.opacity };
  indicatorsName: string = '';
  generatedChartType: string = 'column';

  @Input() impactItems: any;
  chartId: any;
  reportResource = reportTitals;
  componentItemsArray: any;
  componentItemsArrayForChart: any[] = [];
  @Input() isIsoReport = false;

  ngOnChanges(changes: SimpleChanges) {
    this.impactItems = changes['impactItems'].currentValue;
    this.chartId = 'BarChartContainer' + this.impactItems.reportTypeId;
    this.componentItemsArray = this.impactItems.componentItems;
    this.chartOpacity = { value: this.impactItems?.opacity };
    this.indicatorsName = this.impactItems?.indicatorName;
    this.componentItemsArrayForChart = filterZeroValuesForChart(this.componentItemsArray);
  }

  splitterFunc(input: any) {
    return input.includes(';') ? input.split(';') : [input];
  }
}
